/* import __COLOCATED_TEMPLATE__ from './fin-response-details.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();